import React from 'react'
import PropTypes from 'prop-types'
import { LinkButton } from '@sleepstation/components'
import { SIZE } from '@sleepstation/const'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ProgrammeAccessLinkButton = ({ ctaButtonContent, dataCyPrefix }) => (
  <LinkButton
    href={ctaButtonContent.url}
    size={SIZE.SMALL}
    dataCy={`${dataCyPrefix}-therapy-start-button`}
  >
    {ctaButtonContent.labelHasNotStarted}
  </LinkButton>
)

ProgrammeAccessLinkButton.propTypes = {
  ctaButtonContent: PropTypes.object.isRequired,
  dataCyPrefix: PropTypes.string,
}

ProgrammeAccessLinkButton.defaultProps = {
  dataCyPrefix: ``,
}

export default ProgrammeAccessLinkButton
